import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { borderRadius3, borderRadiusFull, colorBgOpacityLight, colorIconHighlight, inputOptionSize, space2, colorIconActionOption, } = theme();
    return StyleSheet.create({
        icon: {
            color: colorIconActionOption,
        },
        inputOptionView: {
            alignItems: "center",
            backgroundColor: colorIconHighlight,
            borderRadius: borderRadiusFull,
            height: inputOptionSize,
            justifyContent: "center",
            position: "absolute",
            right: space2,
            top: space2,
            width: inputOptionSize,
        },
        overlay: {
            backgroundColor: colorBgOpacityLight,
            borderRadius: borderRadius3,
            bottom: 0,
            left: 0,
            pointerEvents: "none",
            position: "absolute",
            right: 0,
            top: 0,
        },
    });
};
export { style };
